ACDiscountApp.CartPage.Show_CalculateTier = function () {
  var TierProducts = [];
  var postDataDiscountArrayObject = [];
  var discountMsg = "QUANTITY_DISCOUNT";

  // Utility function to create a discount object, used in all three discount types.
  function createDiscountObject(msg, variantId, value) {
    return {
      message: msg,
      targets: [{ productVariant: { id: variantId } }],
      value: value,
    };
  }

  // Creates a percentage discount object as per Shopify requirements.
  function createPercentageDiscountObject(msg, percentage, variantId) {
    return createDiscountObject(msg, variantId, {
      percentage: { value: percentage },
    });
  }

  // Creates a fixed amount discount object and calculates the total discount amount.
  function createAmountOffDiscountObject(msg,variantId,currencyRate,amount,qtys ) {
    const totalDiscountedAmount = (amount * currencyRate * qtys).toFixed(2);
    return createDiscountObject(msg, variantId, {
      fixedAmount: { amount: totalDiscountedAmount },
    });
  }

  // Creates a discounted price object and calculates the discount based on the original price.
  function createDiscountedPriceDiscountObject( msg,variantId, currencyRate,amount,qtys,price) {
    const discountAmount = (amount * currencyRate).toFixed(2);
    if (Number(price) > Number(discountAmount)) {
      const discountValue = (price - discountAmount).toFixed(2);
      const totalDiscountedAmount = (discountValue * qtys).toFixed(2);

      return createDiscountObject(msg, variantId, {
        fixedAmount: { amount: totalDiscountedAmount },
      });
    }

    // Return null or a default value if no discount applies (optional based on your use case)
    return null;
  }

  async function setDateTimeInCart() {
    console.log(postDataDiscountArrayObject);
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attributes: {
            Discountly_dateTime: JSON.stringify(postDataDiscountArrayObject),
          },
        }),
      });

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      const data = await response.json();
      await fetch("/cart.js").then((r) =>
        r.json().then((data) => ({ status: r.status, body: data }))
      );
    } catch (error) {
      // console.error('Failed to update cart:', error);
    }
  }

  
    var UpdateCartItem = function (item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index) {
        if (isUpdate) {
            var originalItemPrice = globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), originalLinePrice = globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            var condition1 = updatedItemPrice == originalItemPrice;
            updatedItemPrice = globalFields.ConvertToFixedDecimalString(updatedItemPrice), updatedLinePrice = globalFields.ConvertToFixedDecimalString(updatedLinePrice);
         jQuery('.discounts.list-unstyled').remove();
          jQuery('.anncode').eq(index).remove()
              if (isNotInRange || condition1) {
 
               jQuery('.acmainCartItemPrice').eq(index).html('<span><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></span>');
                jQuery('.drawer__contents.js-contents .cart-item__details').eq(index).find('.product-option:first').html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
               jQuery('.cart-item__totals.right.small-hide .cart-item__price-wrapper').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
                jQuery('#CartDrawer-CartItems .cart-item__totals.right').eq(index).html('<div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
               // jQuery('.discounts.list-unstyled').eq(index).hide()
              }
            else {
                originalItemPrice = globalFields.ConvertToFixedDecimalString(originalItemPrice), originalLinePrice = globalFields.ConvertToFixedDecimalString(originalLinePrice);
               jQuery('.acmainCartItemPrice').eq(index).html('<span class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></span> <span><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></span>');
               jQuery('.drawer__contents.js-contents .cart-item__details').eq(index).find('.product-option:first').html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalItemPrice, globalFields.amount) + '</span></s></div> <div><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedItemPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedItemPrice, globalFields.amount) + '</span></div>');
               jQuery('.cart-item__totals.right.small-hide .cart-item__price-wrapper').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></div> <div style="margin-left:5px"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
               jQuery('#CartDrawer-CartItems .cart-item__totals.right').eq(index).html('<div class="cart-item__original-price"><s><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + originalLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(originalLinePrice, globalFields.amount) + '</span></s></div> <div style="margin-left:5px"><span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedLinePrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedLinePrice, globalFields.amount) + '</span></div>');
               //jQuery('.discounts.list-unstyled').eq(index).show()
              jQuery('.cart__items .cart-item__details').eq(index).append(`<li class="discounts__discount anncode" style="font-size: 0.8em;"><svg aria-hidden="true" focusable="false" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg>QUANTITY_DISCOUNT</li>`)
            }
        }
    }

    var UpdateCartSubtotal = function (isUpdate, updatedTotalPrice, originalTotalPrice) {
        if (isUpdate) {
            updatedTotalPrice = globalFields.ConvertToFixedDecimalString(updatedTotalPrice), originalTotalPrice = globalFields.ConvertToFixedDecimalString(originalTotalPrice);
            if (originalTotalPrice != updatedTotalPrice) {
               jQuery('.cart__blocks .totals__total-value').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
               jQuery('.cart-drawer__footer .totals__total-value').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            }
            else {
               jQuery('.cart__blocks .totals__total-value').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
               jQuery('.cart-drawer__footer .totals__total-value').html('<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + updatedTotalPrice + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(updatedTotalPrice, globalFields.amount) + '</span>');
            }
        }
    }

    var UpdateSavingMessage = function (isUpdate) {
        if (priceDiff > 0 && isUpdate && globalFields.isCartPage) {
            var saveMessage = globalFields.settings.cart_saving_message.replace('{{discount_amount}}', '<span class="money" data-currency-' + globalFields.currency.toLowerCase() + '="' + globalFields.currencySymbol + priceDiff.toFixed(2) + '" data-currency="' + globalFields.currency + '">' + globalFields.formatMoney(priceDiff.toFixed(2), globalFields.amount) + '</span>');
            var saveHtml = '<span id="saved-banner">' + saveMessage + '</span>';
          if (jQuery(window).width() < 700) {
            jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__footer .totals').after('<div id="saved-banner-div" style="text-align: center;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
          else{
           jQuery('#saved-banner-div').length == 0 ? jQuery('.cart__footer .totals').after('<div id="saved-banner-div" style="text-align: end;" class="col-md-14">' + saveHtml + '</div>') : jQuery('#saved-banner-div').html(saveHtml);
          }
        }
        else if (globalFields.isCartPage) {
         //   jQuery('#saved-banner-div').remove();
        }
    }

    var CheckoutClickCart = function () {
        jQuery('#checkout').click(async function (e) {
            e.preventDefault();
            jQuery(`.mainItemError`).remove();
          if(globalFieldsCartPage_AC.cartObj.item_count < 8){
            jQuery(`.cart__ctas`).before(`<h4 class="mainItemError" style="color: #EB5E8F; margin-bottom: 12px; line-height: 1.5;">
  Kindly note our minimum order quantity is now <strong>8x units</strong>.<br>
  Please add additional items to place your order.
</h4>`);
            return false;
          }
               TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
              await  setDateTimeInCart();
               window.location.href = '/checkout';
        });
    }

      jQuery('#checkout').click(async function (e) {
            e.preventDefault();
            jQuery(`.mainItemError`).remove();
          if(globalFieldsCartPage_AC.cartObj.item_count < 8){
            jQuery(`.cart__ctas`).before(`<h4 class="mainItemError" style="color: #EB5E8F; margin-bottom: 12px; line-height: 1.5;">
  Kindly note our minimum order quantity is now <strong>8x units</strong>.<br>
  Please add additional items to place your order.
</h4>`);
            return false;
          }
               TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
              await  setDateTimeInCart();
               window.location.href = '/checkout';
        });

    var CheckoutClickAjax = function () {
        // jQuery('.drawer__footer button[name="checkout"]').click(function (e) {
        //    //  e.preventDefault();
        //    // jQuery('.drawer__footer button[name="checkout"]').text('\n            Loading...\n          ');
        //    //  GetCode(true);
        // });
    }
  let marketregion = globalFields.CuurencyCode();
   // var GetCode = function (isUpper) {
   //      if (priceDiff > 0) {
   //          jQuery.ajax({
   //               type: "POST", async: false, url: "https://customerapp.anncode.com/tier/ACPGenerateDiscountCode",
   //               data: {TierProductsarray:JSON.stringify(TierProducts),priceDifference: priceDiff, subTotal: 1, variantIds: variantIdsToSend.toString(),cartobject:JSON.stringify(globalFieldsCartPage_AC.cartObj) },
   //               success: function (result) {
   //                  var data_ = JSON.stringify(result); var parsed_data = JSON.parse(data_); var PRID = parsed_data.PRID;
   //                  var DCID = parsed_data.DCID; var DiscountCode = parsed_data.DiscountCode;
   //                  SetCookie("discountCodes", PRID + "-" + DCID + "-" + DiscountCode, 30);
   //                  if (!isUpper) {
   //                      DiscountCodeCookie(DiscountCode);
   //                      jQuery('form[action="/cart"]').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
   //                    	window.location.href = '/checkout?discount=' + DiscountCode;
   //                  } else {
   //                      DiscountCodeCookie(DiscountCode);
   //                      //jQuery('form.cart-form').append('<input id="discount_input" type="hidden" name="discount" value="' + DiscountCode + '">');
   //                      window.location.href = '/checkout?discount=' + DiscountCode;
   //                  }
   //              },
   //              error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
   //          });
   //      }
   //      else if (isUpper) {
   //          window.location.href = '/checkout';
   //      }
   //    else{
   //      window.location.href = '/checkout';
   //    }
   //  }
 
    var GetCode = function (isUpper) {
        if (priceDiff > 0) {
          var valueCheck =  globalFields.isCustomer;
          if(valueCheck){
         var temp_CustObject = JSON.stringify({ customer_id:customer_id, customer_first_name:customer_first_name,customer_last_name:customer_last_name, customer_email:customer_email });
          }
           var temp_CustObject = JSON.stringify({ customer_id:customer_id, customer_first_name:customer_first_name,customer_last_name:customer_last_name, customer_email:customer_email });
            jQuery.ajax({
                 type: "POST", async: false, url: "https://customerapp.anncode.com/api/ACPGeneratedraftorderforLifeFormStoreTest",
                 data: {TierProductsarray:JSON.stringify(TierProducts),TaxApply:true,DiscountText:"",temp_CustObject:temp_CustObject,priceDifference: priceDiff, subTotal: minimumDiscountSubtotal, variantIds: variantIdsToSend.toString(),cartItemsObj:JSON.stringify(globalFieldsCartPage_AC.cartObj),MarketRegionCode:marketregion },
                success: function(result) {
                  setTimeout(function() {
                   jQuery('.cart__blocks button[name="accheckout"]').text('\n            Checkout\n          ')
                  jQuery('#cart-notification-form button[name="accheckout"]').text('\n             Check out...\n          ')
                  window.location.href = result;
                  },3000);
                  
                  },
                error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
            });
        }else if(priceDiff > 0){
             var valueCheck =  globalFields.isCustomer;
          if(valueCheck){
         var temp_CustObject = JSON.stringify({ customer_id:customer_id, customer_first_name:customer_first_name,customer_last_name:customer_last_name, customer_email:customer_email });
          }
           var temp_CustObject = JSON.stringify({ customer_id:customer_id, customer_first_name:customer_first_name,customer_last_name:customer_last_name, customer_email:customer_email });
            jQuery.ajax({
                 type: "POST", async: false, url: "https://customerapp.anncode.com/api/ACPGeneratedraftorderforLifeFormStoreTest",
                 data: {TierProductsarray:JSON.stringify([]),TaxApply:true,DiscountText:"",temp_CustObject:temp_CustObject,priceDifference: 0, subTotal: 0, variantIds: variantIdsToSend.toString(),cartItemsObj:JSON.stringify(globalFieldsCartPage_AC.cartObj),MarketRegionCode:marketregion },
                success: function(result) {
                  setTimeout(function() {
                   jQuery('.cart__blocks button[name="accheckout"]').text('\n            Checkout\n          ')
                  jQuery('#cart-notification-form button[name="accheckout"]').text('\n             Check out...\n          ')
                  window.location.href = result;
                  },3000);
                  
                  },
                error: function (e) { console.log(e.statusText); window.location.href = '/checkout'; }
            });
        }
        else if (isUpper) {
            window.location.href = '/checkout';
        }
      else{
        window.location.href = '/checkout';
      }
    }

    var ReInvokeAjaxCartButton = function () {
        jQuery('.mb_cart.mb_item button.btn, .top-header .dropdown-cart button.btn').off("click"); CheckoutClickAjax();
    }

    var variantIdsToSend = [], minimumDiscountSubtotal = 0, priceDiff = 0;

  	var hide_buttons = null;
  	var HideAdditionalPayments = function() {      
      hide_buttons = setInterval(function() {
        if(jQuery('.additional_checkout_buttons, .dynamic-checkout__content').length>0){
          jQuery('.additional_checkout_buttons, .dynamic-checkout__content').hide();
          clearInterval(hide_buttons);
        }
      }, 500);
    }

    var variantIdsToSend = [],
    minimumDiscountSubtotal = 0,
    priceDiff = 0;
  
    var TieredPricingCart = function (cartObject, isUpdate) {
      
        variantIdsToSend = []; minimumDiscountSubtotal = 0; priceDiff = 0; var updatedTotalPrice = 0;TierProducts = [];postDataDiscountArrayObject = [];
    
        for (k = 0; k < cartObject.items.length; k++) {
            var item = cartObject.items[k], isInRange = true; itemTiers = GetTiersFromTiersArray(item.variant_id);
           let validCustomer = globalFields.checkCustomerLooged();
          
          if (itemTiers != undefined && validCustomer && itemTiers.status && globalFields.StartEndDateValid(itemTiers.start_date, itemTiers.end_date)) {
            let DiscountAppliedOn = itemTiers.DiscountAppliedON != null &&  itemTiers.DiscountAppliedON  != '' &&  itemTiers.DiscountAppliedON != undefined ? true : false;
            let Location_Tag_s = itemTiers.Location_Tag_ != null &&  itemTiers.Location_Tag_  != '' &&  itemTiers.Location_Tag_ != undefined ? true : false;
               if(DiscountAppliedOn){
                if(Location_Tag_s){
                   let DiscountAppliedOnTag =itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ? true : false;
                   let LocationObject = Object.keys(itemTiers.Location_Tag_);
                   if(LocationObject[0] == 'StoreLocation'){
                    let StoreLocationcheck =  itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecountry) || itemTiers.Location_Tag_[LocationObject[0]].includes(globalFields.Storecity) ? true : false;
                    if(StoreLocationcheck && DiscountAppliedOnTag){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                      }else{
                      updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                      }
                   }else{
                   let TierLocation = itemTiers.Location_Tag_[LocationObject[0]];
                   let CusotmerCountryLocation = globalFields.Customercountry;
                   let CusotmerCityLocation = globalFields.Customercity;
                   let CustomerLocationcheck_1 = (arr, arr1) =>{return arr.some(item => arr1.includes(item))};
                   let CustomerLocationcheck_2 = (arr2, arr3) =>{return arr2.some(item => arr3.includes(item))};
                   let CityValue = CustomerLocationcheck_1(TierLocation,CusotmerCountryLocation);
                   let CountryValue = CustomerLocationcheck_2(TierLocation,CusotmerCityLocation);
                     if(DiscountAppliedOnTag && (CityValue || CountryValue)){
                        var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                        updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                        if (rslt[1]) {
                        updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                        }
                     }else{
                       updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                     }
                   }
                                                   
                 }else{
                  if(itemTiers.DiscountAppliedON == 'Both_Store' || itemTiers.DiscountAppliedON == 'Online_Store' ){
                   var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                  updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                  if (rslt[1]) {
                  updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                  }
                 }else{
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                 }
                 }
                 
               }else{
                var rslt = CalculateTier(item, itemTiers, updatedTotalPrice, isUpdate, true, k);
                updatedTotalPrice = rslt[0]; isInRange = rslt[1];
                if (rslt[1]) {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
                }
                 
               }

            
             }
            else {
                updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100);
            }
          
            if (!isInRange) {
                minimumDiscountSubtotal += globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100); variantIdsToSend.push(item.variant_id);
            }
        }
        UpdateCartSubtotal(isUpdate, globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice), globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100));
        priceDiff = globalFields.ConvertToFixedDecimalNumber((globalFields.ConvertToFixedDecimalNumber(cartObject.original_total_price / 100) - globalFields.ConvertToFixedDecimalNumber(updatedTotalPrice)));
        UpdateSavingMessage(isUpdate);
      	   setDateTimeInCart();
       setTimeout(function(){
            makeEnableDisablebtn(false)
          }, 800);
      
      if(priceDiff){
          HideAdditionalPayments();
        }
      	setTimeout(function(){
          clearInterval(hide_buttons);
        }, 5000);
    }
    setTimeout(function(){
      clearInterval(hide_buttons);
    }, 10000);
    
    var GetTiersFromTiersArray = function (variantId) {
        var tierObj = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.variant_id === variantId); });
         var checkValue  = tierObj?.[0]?.tiers ?? false;
        if(!checkValue){
          return undefined;
        }
        if (tierObj[0].tiers == "[]") {
            return undefined;
        }
        else {
            return globalFields.GetTierObject(tierObj[0].tiers[0], variantId);
        }
    }
    let wholeSaleTags = globalFields.wholseSaleTags();
    var CalculateTier = function (item, itemTiers, updatedTotalPrice, isUpdate, isNotInRange, index) {
      let isFound = TierProducts.some(element => {if (element.VarientID === item.variant_id) { return true;}return false;});
        for (i = 0; i < itemTiers.tier_min.length; i++) {
            var customerTierExit = false;
            var customerRuleTier  = globalFieldsCartPage_AC?.cartTiersArray?.[0]?.customerTier?.[0] ?? null;
            if(customerRuleTier){
              customerTierExit = true;
            }
            var allVariantItemQty = 0;
            var tierPrice = 0;
            var customerTierPrice = 0;
          if(wholeSaleTags == 'B2B GBP'){
             tierPrice = parseFloat(itemTiers.wholeSaleGbp != undefined ? itemTiers.wholeSaleGbp[i] : itemTiers.tier_values[i]);
             customerTierPrice = parseFloat(customerRuleTier?.wholeSaleGbp != undefined ? customerRuleTier.wholeSaleGbp[0] : customerRuleTier?.tier_values[0]);
          
            }else if (wholeSaleTags == 'B2B EUR' || wholeSaleTags == 'B2B EU') {
             tierPrice = parseFloat(itemTiers?.wholeSaleEur != undefined ? itemTiers.wholeSaleEur[i] : itemTiers?.tier_values[i]);
             customerTierPrice = parseFloat(customerRuleTier?.wholeSaleEur != undefined ? customerRuleTier.wholeSaleEur[0] : customerRuleTier?.tier_values[0]);
            } else if (wholeSaleTags == 'B2B USD' || wholeSaleTags == 'B2B US'){
             tierPrice = parseFloat(itemTiers.wholeSaleUsd != undefined ? itemTiers.wholeSaleUsd[i] : itemTiers.tier_values[i]);
             customerTierPrice = parseFloat(customerRuleTier?.wholeSaleUsd != undefined ? customerRuleTier.wholeSaleUsd[0] : customerRuleTier?.tier_values?.[0]);
            }else{
            tierPrice =  parseFloat(itemTiers.tier_values[i]);
            customerTierPrice =  0;
          }
      let tempTierProductsobj = {};
      let postDataDiscountObject = {};
            var minTier = parseInt(itemTiers.tier_min[i]), maxTier = itemTiers.tier_max[i] != 'max' ? parseInt(itemTiers.tier_max[i]) : itemTiers.tier_max[i];
            var customer_minTier = customerTierExit ? parseInt(customerRuleTier.tier_min[0]) : 0;
            var customer_maxTier = customerTierExit ? customerRuleTier.tier_max[0] != 'max' ? parseInt(customerRuleTier.tier_max[0]) : customerRuleTier.tier_max[0] : 0;
            
            var updatedItemPrice = 0, updatedLinePrice = 0, condition1 = false, condition2 = false;
           var condition_customer1 = false;
           var condition_customer2 = false;
            if (itemTiers.entity_type === 'products' || itemTiers.entity_type === 'collections') {
                var tempItemArray = [];
                if (itemTiers.entity_type === 'collections') {
                    var tempTierArray = jQuery.grep(globalFieldsCartPage_AC.cartTiersArray, function (n) { return (n.tiers != '[]' && n.tiers[0].entity_type == 'collections' && n.tiers[0].entity_id == itemTiers.entity_id); });
                    for (var m = 0; m < tempTierArray.length; m++) {
                        var temp = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.variant_id == tempTierArray[m].variant_id); });
                        if (temp.length != 0) {
                            tempItemArray.push(temp[0]);
                        }
                    }
                }
                else {
                    tempItemArray = jQuery.grep(globalFieldsCartPage_AC.cartObj.items, function (n) { return (n.product_id == item.product_id ); });
                }

              if (itemTiers.entity_type === 'products') { 
                 for (j = 0; j < tempItemArray.length; j++) { allVariantItemQty += tempItemArray[j].quantity; }
              } else { 
                var eligibleItems = globalFieldsCartPage_AC.cartObj.items.filter(cartItem => {
                if (globalFieldsCartPage_AC.cartTiersArray.some(item => item.product_id==(cartItem.product_id))) {
                allVariantItemQty += cartItem.quantity;
                return true;
                }
                return false;
                });
              }
                condition1 = allVariantItemQty >= minTier;
                condition2 = maxTier == "max" || allVariantItemQty <= maxTier;
                condition_customer1 = allVariantItemQty >= customer_minTier;
                condition_customer2 = customer_maxTier == "max" || allVariantItemQty <= customer_maxTier;
            }
            else {
                condition1 = item.quantity >= minTier;
                condition2 = maxTier == "max" || item.quantity <= maxTier;
            }

                if (condition1 && condition2) {
        var Vid = `gid://shopify/ProductVariant/${item.variant_id}`;
       //var currencyRate = Shopify.currency.rate;
        var currencyRate = 1;
        var qtys = item.quantity;
        var price = Number(item.original_price / 100).toFixed(2);
        isNotInRange = false;
        if (itemTiers.discount_type == "percentage") {
          var originalPriceCut = parseFloat(
            globalFields.ConvertToFixedDecimalNumber(
              (parseFloat(tierPrice) / 100) *
                globalFields.ConvertToFixedDecimalNumber(
                  item.original_price / 100
                )
            )
          );
          updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(
            globalFields.ConvertToFixedDecimalNumber(
              item.original_price / 100
            ) - originalPriceCut
          );
          if (!isFound) {
            tempTierProductsobj["Discountvalue"] = tierPrice* currencyRate;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = item.variant_id;
            let resposne = createPercentageDiscountObject( discountMsg, tierPrice,  Vid);
            postDataDiscountObject = resposne;
          }
        } else if (itemTiers.discount_type == "fixed") {
          updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(
            globalFields.ConvertToFixedDecimalNumber(
              item.original_price / 100
            ) - parseFloat(tierPrice* currencyRate)
          );
          if (!isFound) {
            tempTierProductsobj["Discountvalue"] = tierPrice* currencyRate;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
            let resposne = createAmountOffDiscountObject( discountMsg, Vid, currencyRate, tierPrice, qtys );
            postDataDiscountObject = resposne;
          }
        }
        else if (itemTiers.discount_type == "fixed_price") {
          updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(
            parseFloat(tierPrice* currencyRate)
          );
         if(condition_customer1 && condition_customer2 && customerTierPrice > 0){
          var originalPriceCustomerCut = parseFloat(
            globalFields.ConvertToFixedDecimalNumber(
              (parseFloat(customerTierPrice) / 100) *
                globalFields.ConvertToFixedDecimalNumber(
                  updatedItemPrice
                )
            )
          );
          updatedItemPrice = globalFields.ConvertToFixedDecimalNumber(
            globalFields.ConvertToFixedDecimalNumber(
              updatedItemPrice
            ) - originalPriceCustomerCut
          );
         }
          if (!isFound) {
            tempTierProductsobj["Discountvalue"] = updatedItemPrice* currencyRate;
            tempTierProductsobj["DiscountType"] = itemTiers.discount_type;
            tempTierProductsobj["VarientID"] = `gid://shopify/ProductVariant/${item.variant_id}`;
            let resposne = createDiscountedPriceDiscountObject(discountMsg,Vid,currencyRate,updatedItemPrice,qtys,price);
            postDataDiscountObject = resposne;
          }
        }
        if (updatedItemPrice < 0) {
          updatedItemPrice = 0;
        }
                if(updatedItemPrice <= item.original_price/100){
                    updatedLinePrice = globalFields.ConvertToFixedDecimalNumber(updatedItemPrice * item.quantity);
                    updatedTotalPrice += globalFields.ConvertToFixedDecimalNumber(updatedLinePrice);
                    UpdateCartItem(item, updatedItemPrice, updatedLinePrice, isNotInRange, isUpdate, index);
                }else{isNotInRange = true}
        if (!isFound) {
          if (postDataDiscountObject != null) {
            postDataDiscountArrayObject.push(postDataDiscountObject);
          TierProducts.push(tempTierProductsobj);
          }
        }
      }
        
        }
        if (isNotInRange) {
            UpdateCartItem(item, globalFields.ConvertToFixedDecimalNumber(item.original_price / 100), globalFields.ConvertToFixedDecimalNumber(item.original_line_price / 100), isNotInRange, isUpdate, index);
        }
        return [updatedTotalPrice, isNotInRange];
    }

    var DiscountCodeCookie = function (discount_code) {
        jQuery.ajax({
            type: "HEAD", url: "/discount/" + discount_code,
            success: function (_result) { },
            error: function (e) { console.log(e.statusText); }
        })
    }

    
    var FetchCartTiers = function () {
        jQuery.ajax({
            async: false,
            url: "/cart/?view=ac_cart_tiers",
            success: function (result) {
                globalFieldsCartPage_AC.cartTiersArray = JSON.parse(result);
              if(globalFieldsCartPage_AC.cartObj.item_count >= 8){
          jQuery(`.mainItemError`).remove();
          }
                TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
               jQuery('.discounts.list-unstyled').remove();
          
                 //CheckoutClickAjax();
            },
            error: function (e) { console.log(e.statusText); }
        });
    }
    /*
        var open = window.XMLHttpRequest.prototype.open, send = window.XMLHttpRequest.prototype.send, onReadyStateChange;
        function openReplacement(method, url, async, user, password) { return open.apply(this, arguments); }
        function sendReplacement(data) {
            this.onreadystatechange = function () {
                if (this.readyState == 4 && this.status == 200) {
                    ProcessCartResponse(this._url, this.responseText);
                }
            };
            return send.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement; window.XMLHttpRequest.prototype.send = sendReplacement;
    */
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
        ProcessCartResponse(settings.url, xhr.responseText);
    });

    var ProcessCartResponse = function (splittedUrl, responseText) {
        if (splittedUrl != 'undefined' && splittedUrl != "" && splittedUrl != null) {
            splittedUrl = splittedUrl.split("?");
            if (splittedUrl[0] == "/cart.js" || splittedUrl[0] == "/cart/change.js" || splittedUrl[0] == "/cart/add.js") {
                globalFieldsCartPage_AC.cartObj = JSON.parse(responseText);
                setTimeout(function () {
                    FetchCartTiers();
                }, 1200);
            }
        }
    }

    try{
        var nativeFetch = window.fetch;
        window.fetch = function(...args) {
          if(args[0].includes("/cart/change") || args[0].includes("/cart/add")){
            setTimeout(function () {
              fetch('/cart.js')
              .then(r =>  r.json().then(data => ({status: r.status, body: data})))
              .then(obj => ProcessCartResponse("/cart.js", JSON.stringify(obj.body)));
            }, 1500);
          }
          return nativeFetch.apply(window, args);
        }
      }
      catch(e){}
    jQuery(document).ready(function () {
    jQuery(document).on("keyup", "input.quantity__input", function () {
      makeEnableDisablebtn(true)
      setTimeout(() => {
        jQuery(this).blur(); // Triggers the blur event
      }, 800);
    });
        jQuery(document).on("click", `button[name="plus"],button[name="minus"]`, function () {
      makeEnableDisablebtn(true)
      setTimeout(() => {
        jQuery(this).blur(); // Triggers the blur event
      }, 800);
    });
    jQuery(document).on("blur", "input.quantity__input", function () {
      setTimeout(() => {
         TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
      }, 2000);
    });
  });
  

    function makeEnableDisablebtn(isEnable) {
    if(isEnable){
       jQuery('#checkout').prop('disabled', true);
     // jQuery('#checkout').text('\n                    \n                      Loading...\n                    \n                  ')
     

    }else{
    //  jQuery('#checkout').text('\n                    \n                      Checkout\n                    \n                  ')
      jQuery('#checkout').prop('disabled', false);
    }
  }
  
  
    var SetCookie = function (cname, cvalue, exdays) { var d = new Date(); d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000)); var expires = "expires=" + d.toUTCString(); document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; }
    TieredPricingCart(globalFieldsCartPage_AC.cartObj, true);
  CheckoutClickCart(); CheckoutClickAjax();

}

var globalFieldsCartPage_AC = new ACDiscountApp.CartPage.Global(); var cartObject = new ACDiscountApp.CartPage.Show_CalculateTier();